import { NotifyHelper } from "../../../helpers/toast";
import { eLoaiChungChiDanhSachMonActionsObj } from "../../action-types/chuong-trinh-dao-tao/ILoaiChungChiDanhSachMonActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const loaiChungChiDanhSachMonActions = {
    ...generateActions(eLoaiChungChiDanhSachMonActionsObj, "LOAI_CHUNG_CHI_DANH_SACH_MON"),
    ...generateActionForKey(eLoaiChungChiDanhSachMonActionsObj, "LOAI_CHUNG_CHI_DANH_SACH_MON", "SYS_SUCCESS", (m) => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eLoaiChungChiDanhSachMonActionsObj, "LOAI_CHUNG_CHI_DANH_SACH_MON", "SYS_ERROR", (m) => { NotifyHelper.Error(m) }),
}